// Ambalaj ve barkodlar: kutu, paket, koli, palet… ve ek barkodlar. Yalnız ürün tipinde görünür.
import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PackagingEditor from '../packaging/PackagingEditor';
import type { StockCardForm } from '../useStockCardForm';
import { SectionTitle } from './fields';

export const PackagingSection: React.FC<{ f: StockCardForm }> = ({ f }) => {
  const { t } = useTranslation('accounting');
  const salePrice = typeof f.salePrice === 'number' ? f.salePrice : Number(String(f.salePrice).replace(',', '.'));

  return (
    <Box>
      <SectionTitle
        title={t('stock.addModal.layout.sections.packaging', 'Ambalaj ve barkodlar')}
        hint={t('stock.packaging.sectionHint', 'Koli, paket gibi ambalajları ve barkodlarını tanımlayın. Ambalaj barkodu okutulunca sayımda, satışta ve faturada içindeki miktar kadar işlem yapılır; stok her zaman ana birimde tutulur.')}
      />
      <PackagingEditor
        ref={f.unitsEditorRef}
        itemId={f.isEditMode ? f.itemToEdit?.id : null}
        baseUnit={f.unit}
        mainBarcode={f.barcode}
        itemSalePrice={Number.isFinite(salePrice) ? salePrice : 0}
        productionEnabled={f.productionEnabled}
        onBaseUnitLocked={f.setBaseUnitLocked}
      />
    </Box>
  );
};
